import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="m9.8 16.175 6.5-4.225-6.5-4.225zM3.5 20q-.6 0-1.05-.45T2 18.5v-13q0-.6.45-1.05T3.5 4h17q.6 0 1.05.45T22 5.5v13q0 .6-.45 1.05T20.5 20zm0-1.5v-13zm0 0h17v-13h-17z" />
, 'CameraVideoVideoOutlinedx');
